// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__15SXk","container":"footer_container__3uPeV","logo":"footer_logo__INZ5p"};